"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(types) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      isFetching: false
    };
    var action = arguments[1];

    switch (action.type) {
      case types.request:
        return _extends({}, state, {
          isFetching: true
        });

      case types.success:
        return _extends({}, state, {
          isFetching: false,
          data: action.payload.body,
          lastUpdated: action.payload.meta.receivedAt,
          error: void 0
        });

      case types.failure:
        return _extends({}, state, {
          isFetching: false,
          error: action.payload.message
        });

      default:
        return state;
    }
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-server-middleware/lib/helpers/createApiReducer.js
// module id = 1216
// module chunks = 0